import React from 'react';
import { Card, Space, Typography } from 'antd';
import { Link } from 'react-router';
import type { Proposal } from '../../types/proposal';
import { ProposalStatusTag } from './ProposalStatusTag';

const { Text, Title } = Typography;

interface ProposalCardProps {
  proposal: Proposal;
  viewPath: string;
  editPath?: string;
}

export const ProposalCard: React.FC<ProposalCardProps> = ({ proposal, viewPath, editPath }) => {
  const address = proposal.mapResult?.map?.address || 'Address pending';
  const snapshot = proposal.mapResult?.snapshot || null;

  return (
    <Card>
      <Space direction="vertical" size={12} style={{ width: '100%' }}>
        {snapshot && (
          <div
            style={{
              width: '100%',
              height: 200,
              borderRadius: 12,
              overflow: 'hidden',
              backgroundColor: '#f5f5f5'
            }}
          >
            <img
              src={snapshot}
              alt="Map preview"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
        )}
        <Space direction="vertical" size={4}>
          <Title level={5} style={{ margin: 0 }}>
            Proposal {proposal.id.slice(-6).toUpperCase()}
          </Title>
          <Text type="secondary">{address}</Text>
        </Space>
        <Space size={12} align="center">
          <ProposalStatusTag status={proposal.status} />
          <Space size={16}>
            <Link to={viewPath}>View</Link>
            {editPath && <Link to={editPath}>Edit</Link>}
          </Space>
        </Space>
      </Space>
    </Card>
  );
};
